import { Alert } from '@mui/material';
import { CustomContentProps, SnackbarContent } from 'notistack';
import React, { forwardRef } from 'react';

export const SuccessNotification = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ ...props }, ref) => {
    return (
      <SnackbarContent ref={ref}>
        <Alert
          severity="success"
          elevation={6}
          variant="filled"
          sx={{
            color: 'white',
          }}
        >
          <b>Success: </b>
          {props.message}
        </Alert>
      </SnackbarContent>
    );
  },
) as unknown as {
  ({ ...props }: CustomContentProps & { ref?: React.Ref<HTMLDivElement> }): JSX.Element;
  displayName: string;
};
SuccessNotification.displayName = 'SuccessNotification';

export const ErrorNotification = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ ...props }, ref) => {
    return (
      <SnackbarContent ref={ref}>
        <Alert
          severity="error"
          elevation={6}
          variant="filled"
          sx={{
            color: 'white',
          }}
        >
          <b>Error: </b>
          {props.message}
        </Alert>
      </SnackbarContent>
    );
  },
) as unknown as {
  ({ ...props }: CustomContentProps & { ref?: React.Ref<HTMLDivElement> }): JSX.Element;
  displayName: string;
};
ErrorNotification.displayName = 'ErrorNotification';
